export default "__VITE_ASSET__ZBYkYxFs__"